import { Component, Input, OnInit, output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';
import { IAvailabilityData, SettingsService } from 'core-lib';
import { ISmCategory } from 'core-lib';
import { LanguageService } from 'core-lib';
import { AvailabilityRoom2RateComponent } from "../availability-room-2-rate/availability-room-2-rate.component";

@Component({
    selector: 'app-more-rates-popup',
    imports: [ButtonModule, DrawerModule, AvailabilityRoom2RateComponent],
    templateUrl: './more-rates-popup.component.html',
    styleUrl: './more-rates-popup.component.scss'
})
export class MoreRatesPopupComponent implements OnInit {

  @Input() roomData: any; 
  @Input() visible:boolean = false;
  onHideRoomPopup:any = output();  
  roomSelected = output<IAvailabilityData>();
  language:string;

  constructor(private settings:SettingsService, private languageService: LanguageService){}

  ngOnInit(): void {
    this.language = this.languageService.getCurrentLanguage();
  }

  handleOnHide() {
    this.onHideRoomPopup.emit();
  }

  getCategoryName(categoryValue:string) {
    let categories = this.settings.get('searchMask.categories');
    if (categories && categories.length > 0) {
      let cat = categories.find((item:ISmCategory) => item.value == categoryValue);
      if (cat) {
        return cat.name[this.language] || cat.name.en || cat.name;
      }
    }
    
  }

  selectRoomRate(rate:any) {
    this.roomSelected.emit(rate);
  }
}
